const initialState = {
  section: "",
  isAuthenticated: false,
  filters: {},
  formFields: [],
  search: "",
  notifications: [],
  loading: false,
  loadMessage: "Please wait...",
  openSidebar: false,
  showSearchWidgetIn: ["Startups", "Dashboard"],
  selectedInvestor: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "SectionSelected":
      return {
        ...state,
        section: action.payload,
      };
    case "LoginUser":
      return {
        ...state,
        isAuthenticated: true,
      };
    case "LogoutUser":
      return {
        ...state,
        isAuthenticated: false,
      };
    case "AddFilters":
      return {
        ...state,
        filters: action.payload,
      };
    case "AddSearch":
      return {
        ...state,
        search: action.payload,
      };
    case "AddNotification":
      return {
        ...state,
        notifications: action.payload,
      };
    case "MarkAsRead":
      var readNotifications = state.notifications.map((noti) => {
        if (action.payload.includes(noti.id)) {
          noti.seen = true;
        }
        return noti;
      });
      return {
        ...state,
        notifications: readNotifications,
      };
    case "AddFilterFields":
      return {
        ...state,
        formFields: action.payload,
      };
    case "toggleLoad":
      return {
        ...state,
        loading: !state.loading,
      };
    case "loadMessage":
      return {
        ...state,
        loadMessage: action.payload,
      };
    case "showSidebar":
      return {
        ...state,
        showSidebar: action.payload,
      };
    case "replaceSelectedInvestor":
      return {
        ...state,
        selectedInvestor: action.payload,
      };
    case "addSelectedInvestor":
      return {
        ...state,
        selectedInvestor: [...state.selectedInvestor, action.payload],
      };
    case "removeSelectedInvestor":
      const newSelectedInvestor = state.selectedInvestor.filter(
        (investor) => investor.investor_id !== action.payload
      );
      return {
        ...state,
        selectedInvestor: newSelectedInvestor,
      };
    case "clearSelectedInvestor":
      return {
        ...state,
        selectedInvestor: [],
      };
    default:
      return state;
  }
};
export default reducer;
